import React from 'react'
import PropTypes from 'prop-types'
import LoginButton from './LoginButton'

/**
 * A react component that is used to control the users login actions.
 * It provides a 'Login' button if the user is not logged in and a
 * 'Logout' button if they are logged in along side the users name
 */
const UserLoginControl = (props) => (
	props.visible
		?
		<div className="UserLoginControl">
			{React.Children.map(props.children, (child) => React.cloneElement(child, {click: props.click}))}
		</div>
		:
		null
)

UserLoginControl.propTypes = {
	visible: PropTypes.bool.isRequired,
	/** The function to perform when the 'Login' button is clicked */
	click: PropTypes.func.isRequired,
	children: PropTypes.element.isRequired
}

UserLoginControl.defaultProps = {
	children: <LoginButton text='Log In'/>
}

export default UserLoginControl  


// WEBPACK FOOTER //
// ./src/components/UserLoginControl/UserLoginControl.js